// assets
import { IconDashboard, IconReport, IconWriting } from '@tabler/icons-react';
import ListIcon from '@mui/icons-material/List';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';

// constant
const icons = { IconDashboard, IconReport, IconWriting, ListIcon, ManageHistoryIcon };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    roles: ['super_admin', 'system_admin'],
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard/default',
            icon: icons.IconDashboard,
            breadcrumbs: false,
            // 🔒 All authenticated users in this layout can see the dashboard
            roles: ['super_admin', 'system_admin'],
            permissions: ['dashboard.read']
        },
        {
            id: 'reports',
            title: 'Reports',
            type: 'collapse',
            icon: icons.IconReport,
            // 🔒 Visible to anyone who can read projects
            permissions: ['projects.read'],

            children: [
                {
                    id: 'completed-projects',
                    title: 'Completed Projects',
                    type: 'item',
                    url: '/completed-projects',
                    target: false,
                    permissions: ['projects.read']
                },
                {
                    id: 'ongoing-projects',
                    title: 'Ongoing Projects',
                    type: 'item',
                    url: '/ongoing-projects',
                    target: false,
                    permissions: ['projects.read']
                },
                {
                    id: 'to-be-launched-projects',
                    title: 'To Be Launched Projects',
                    type: 'item',
                    url: '/to-be-launched-projects',
                    target: false,
                    permissions: ['projects.read']
                },
                {
                    id: 'deferred-projects',
                    title: 'Deferred Projects',
                    type: 'item',
                    url: '/deferred-projects',
                    target: false,
                    permissions: ['projects.read']
                },
                {
                    id: 'cancelled-projects',
                    title: 'Cancelled Projects',
                    type: 'item',
                    url: '/cancelled-projects',
                    target: false,
                    permissions: ['projects.read']
                },
                {
                    id: 'dlp',
                    title: 'DLP',
                    type: 'item',
                    url: '/dlp-projects',
                    target: false,
                    permissions: ['projects.read']
                },
                {
                    id: 'deleted-projects',
                    title: 'Deleted Projects',
                    type: 'item',
                    url: '/deleted-projects',
                    target: false,
                    // 🔒 Only admins should see deleted records
                    roles: ['super_admin', 'system_admin']
                },
                {
                    id: 'financial',
                    title: 'Financial',
                    type: 'item',
                    url: '/under-construction',
                    target: false,
                    permissions: ['financial_records.read']
                }
            ]
        },
        {
            id: 'contracts',
            title: 'Contracts Awarded',
            type: 'collapse',
            icon: icons.IconWriting,
            permissions: ['contracts.read'],

            children: [
                {
                    id: 'contracts-education',
                    title: 'Education (MOET)',
                    type: 'item',
                    url: '/under-construction',
                    target: false,
                    permissions: ['contracts.read']
                },
                {
                    id: 'contracts-capital-projects',
                    title: 'Capital Projects',
                    type: 'item',
                    url: '/under-construction',
                    target: false,
                    permissions: ['contracts.read']
                },
                {
                    id: 'contracts-health',
                    title: 'Health',
                    type: 'item',
                    url: '/under-construction',
                    target: false,
                    permissions: ['contracts.read']
                },
                {
                    id: 'contracts-other',
                    title: 'Other Ministries',
                    type: 'item',
                    url: '/under-construction',
                    target: false,
                    permissions: ['contracts.read']
                },
                {
                    id: 'contracts-rdf',
                    title: 'RDF',
                    type: 'item',
                    url: '/under-construction',
                    target: false,
                    permissions: ['contracts.read']
                }
            ]
        },
        {
            id: 'utils',
            title: 'Utilities',
            type: 'collapse',
            icon: icons.ListIcon,
            roles: ['super_admin', 'system_admin', 'technical_support'],

            children: [
                {
                    id: 'project_number',
                    title: 'Project Number Generator',
                    type: 'item',
                    url: '/project_number',
                    target: false,
                    roles: ['technical_support'],
                    permissions: ['projects.create']
                },
                {
                    id: 'projects',
                    title: 'Manage Projects',
                    type: 'item',
                    url: '/projects',
                    target: false,
                    roles: ['project_manager', 'department_head'],
                    permissions: ['projects.read', 'update']
                },
                {
                    id: 'years',
                    title: 'Manage Financial Year',
                    type: 'item',
                    url: '/financial_year',
                    target: false,
                    roles: ['system_admin', 'super_admin'],
                    permissions: ['dashboard.read', 'funds.create']
                },
                {
                    id: 'funds',
                    title: 'Manage Funds',
                    type: 'item',
                    url: '/funds',
                    target: false,
                    roles: ['system_admin', 'super_admin'],
                    permissions: ['funds.read']
                },
                {
                    id: 'sectors',
                    title: 'Manage Sectors',
                    type: 'item',
                    url: '/sectors',
                    target: false,
                    roles: ['system_admin', 'super_admin'],
                    permissions: ['sectors.read']
                },
                {
                    id: 'departments',
                    title: 'Manage Departments',
                    type: 'item',
                    url: '/departments',
                    roles: ['system_admin', 'super_admin'],
                    permissions: ['departments.read'],
                    target: false
                },
                {
                    id: 'roles',
                    title: 'Manage MPP Roles',
                    type: 'item',
                    url: '/roles',
                    roles: ['system_admin', 'super_admin'],
                    // 🔒 Only users who can manage roles
                    permissions: ['users.manage_roles'],
                    target: false
                },
                {
                    id: 'users',
                    title: 'Manage MPP Officers',
                    type: 'item',
                    url: '/users',
                    roles: ['system_admin', 'super_admin'],
                    permissions: ['users.read'],
                    target: false
                },
                {
                    id: 'contracts',
                    title: 'Manage Contracts',
                    type: 'item',
                    url: '/contracts',
                    target: false,
                    permissions: ['contracts.read']
                },
                {
                    id: 'reports',
                    title: 'Manage Site Reports',
                    type: 'item',
                    url: '/reports',
                    target: false,
                    permissions: ['reports.read']
                },
                {
                    id: 'reports-analytics',
                    title: 'Analytic Reports',
                    type: 'item',
                    url: '/reports-analytics',
                    target: false,
                    permissions: ['reports.read']
                },
                {
                    id: 'contractors',
                    title: 'Contractors Database',
                    type: 'item',
                    url: '/contractors',
                    target: false,
                    permissions: ['contractors.read']
                },
                {
                    id: 'suppliers',
                    title: 'Suppliers Database',
                    type: 'item',
                    url: '/suppliers',
                    target: false,
                    permissions: ['suppliers.read']
                },
                {
                    id: 'gallery',
                    title: 'Gallery',
                    type: 'item',
                    url: '/gallery',
                    target: false,
                    // 🔒 Reports or project read gives gallery access
                    permissions: ['projects.read', 'reports.read']
                }
            ]
        },
        {
            id: 'audit',
            title: 'Audit Logs',
            type: 'item',
            icon: icons.ManageHistoryIcon,
            url: '/audit-logs',
            target: false,
            // 🔒 Admins and accounting officers only
            roles: ['super_admin', 'system_admin', 'department_head'],
            permissions: ['audit_logs.read']
        }
    ]
};

export default dashboard;
